export default __webpack_public_path__ + "static/media/two.4b4e9d26.svg";